module.exports = __webpack_public_path__ + "static/media/RecomendaCarnaval.2ca5a752.jpg";